module.exports = __webpack_public_path__ + "ClientApp/content/BlockRichResources/Bohdi5-fixed.jpg";